import React, { useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Wrapper,
  Title,
  PriceConceptWraper,
  ButtonPrevWrapper,
  ButtonNextWrapper,
  ButtonActionsWrapper,
  Information,
  Closure,
  ClosureInfo,
  Footer
} from './styled';
import { ButtonsAction } from '@app/src/common/ButtonsAction';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { ABREV_MONTHS, getStateConfig } from '@app/src/common/datePicker/state/calendar/constants';
import { DateSelectedType } from '@app/src/common/datePicker/types/Date';
import { addDateSelected, addDateSelectedAll, deleteDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { PriceConcept } from '@app/src/common/PriceConcept';
import { AsideModal } from '@app/src/common/AsideModal';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { SectionDateSelected } from '@app/src/common/datePicker';
import { SectionExtracharges, TypePublicationModel, clearExtracharge } from '@app/src/views/StepTwo/channelPublication';
import { setPriceTotalByChannel } from '@app/src/views/StepOne/form/state/priceTotal/actions';

interface Props {
  printData: TypePublicationModel;
  handleClickNext: Function;
  handleClickBack: Function;
  title: string;
  priceAside: number;
  open: boolean;
  handleClickOutSide: Function;
  categoryId?: number;
}

export const DatePicker: React.FC<Props> = ({
  printData,
  handleClickNext,
  handleClickBack,
  title,
  priceAside,
  open,
  handleClickOutSide,
  categoryId
}) => {

  const dispatch = useDispatch();
  const { id, priceIgv, packageId, price} = printData;
  const dateSelected = useSelector(state => state.calendar);
  let currentDateSelected = dateSelected[getStateConfig[id]];
  const isButtonNextDisabled: boolean = currentDateSelected && currentDateSelected.length === 0;
  const categoryTheme = CATEGORIES[CATEGORY[categoryId]];
  const [ isShowExtracharges, setIsShowExtracharges ] = useState(false);
  const currentPriceTotal = useSelector(state => state.priceTotal.value);
  const priceTotalData = useSelector(state => state.priceTotal.data);
  const [ priceIgvExtracharge, setPriceIgvExtracharge ] = useState(0);
  const [ priceExtracharge, setPriceExtracharge ] = useState(0);
  const extracharges = useSelector(state => state.extracharge.data[id]);
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const extraWords = useSelector(state => state.print.general.extraWords);
  const [isShowPhotoVignette, setIsShowPhotoVignette] = useState(false);

  useEffect(() => {
    if (printsByChannel && printsByChannel[id]) {
      dispatch(addDateSelectedAll(printsByChannel[id], id))
    }
  }, [printsByChannel]);

  useEffect(() => {
    if (extracharges && extracharges.data && extracharges.data.length > 0) {
      let price = 0;
      let priceIgv = 0;
      extracharges.data.map((item) => {
        if (item.checked === true) {
          if (item.alias === 'palabra-extra') {
            price = price + (item.price * extraWords);
            priceIgv = priceIgv + (item.priceIgv * extraWords);
          } else {
            price = price + item.price;
            priceIgv = priceIgv + item.priceIgv;
          }
        }
        if (item.input === 'photoVignette') {
          setIsShowPhotoVignette(true)
        }
      });
      setPriceExtracharge(price);
      setPriceIgvExtracharge(priceIgv);
    }
  }, [extracharges]);

  useEffect(() => {
    if (priceTotalData && Object.keys(priceTotalData).length > 0) {
      let currentPrice= 0;
      Object.keys(priceTotalData).map((id) => {
        currentPrice = currentPrice + priceTotalData[id].priceIgv;
      });
    }
  }, [priceTotalData]);

  useEffect(() => {
    dispatch(setPriceTotalByChannel(id,
      {
        price: (price + priceExtracharge)*(currentDateSelected && currentDateSelected.length),
        priceIgv: (priceIgv + priceIgvExtracharge)*(currentDateSelected && currentDateSelected.length)
      }));
  }, [priceIgvExtracharge, currentDateSelected, priceExtracharge]);

  const handleAddDay = useCallback(
    (date: DateSelectedType) => {
      dispatch(addDateSelected(date, id));
    },
    [dispatch]
  );

  const handleDeleteDay = useCallback(
    (date: DateSelectedType) => {
      dispatch(deleteDateSelected(date, id));
      if (currentDateSelected && currentDateSelected.length === 0) {
        dispatch(clearExtracharge(id));
      }
    },
    [dispatch, currentDateSelected]
  );

  const handleClickDay = (day: DayType) => {
    const isSameDate = currentDateSelected && currentDateSelected.filter(e => e && day && e.dayMonth === day.dayMonth && e.month === day.month);
    if (!(isSameDate && isSameDate.length)) {
      const fullDate: string = `${day.dayName}. ${day.dayMonth} ${ABREV_MONTHS[day.month]}.`
      const selected = {
        dayMonth: day.dayMonth,
        month: day.month,
        year: day.year,
        fullDate,
        stateMonth: day.stateMonth
      }
      handleAddDay(selected);
    }
    const datePicked = dateIsSelected(day);
    if (datePicked){
      handleDeleteDay(datePicked);
    }
  };

  const dateIsSelected = (day: DayType) => {
    return currentDateSelected && currentDateSelected.filter(e => e && day && e.dayMonth === day.dayMonth && e.month === day.month && e.year === day.year)[0];
  };

  const handleClickDateSelected = (date: DateSelectedType) => {
    handleDeleteDay(date);
  };

  const getDataFromCalendar = () => ({
      id,
      packageId,
      printDate: currentDateSelected
  });

  const handleModal = (toggle: boolean) => {
    setIsShowExtracharges(false);
    handleClickOutSide && handleClickOutSide(toggle, getDataFromCalendar());
  };

  const convertToArray = (text: string) => text.split(',');

  const setTextButtonNext = () => !isShowExtracharges ? 'Siguiente' : 'Confirmar';

  const propClickNext = () => {
    if (isShowExtracharges) {
      handleClickNext && handleClickNext(getDataFromCalendar());
      setIsShowExtracharges(false);
    } else {
      setIsShowExtracharges(true);
    }
  };

  const propClickBack = () => {
    if (isShowExtracharges) {
      setIsShowExtracharges(false);
    } else {
      handleClickBack && handleClickBack();
    }
  };

  const getPrice = (price) => {
    setPriceExtracharge(price.price)
    setPriceIgvExtracharge(price.priceIgv);
  };

  return(
    <AsideModal
      message={categoryTheme && categoryTheme.discountMessage}
      title={title}
      price={priceAside}
      isOpen={open}
      handleClickOutSide={handleModal}
      children={
        <React.Fragment>
          <Wrapper>
            <Title>¿Cuándo quieres publicar?</Title>
            {
              !isShowExtracharges ?
                <SectionDateSelected
                  currentDateSelected={currentDateSelected}
                  categoryTheme={categoryTheme}
                  handleClickDateSelected={handleClickDateSelected}
                  handleClickDay={handleClickDay}
                />
              :
                <SectionExtracharges
                  isShowPhotoUploader={isShowPhotoVignette}
                  categoryTheme={categoryTheme}
                  printData={printData}
                  getPrice={getPrice} />
            }
            <Information>
              <Closure>Cierre de publicación:</Closure>
              {
                convertToArray(printData.description).map((date, index) => (
                  <ClosureInfo key={index}>- {date}</ClosureInfo>
                ))
              }
            </Information>
          </Wrapper>
          <Footer>
            <PriceConceptWraper>
              <PriceConcept
                bgColor={`rgba(${categoryTheme && categoryTheme.colorRgba}, .2)`}
                priceTotal={currentPriceTotal} />
            </PriceConceptWraper>
            <ButtonActionsWrapper>
              <ButtonsAction
                ButtonPrev={
                  <ButtonPrevWrapper
                    handleClick={propClickBack}
                    background='#FFFFFF'
                    color={categoryTheme && categoryTheme.color}
                    width={160}
                    text="¿Dónde quieres publicar?"
                    icon={{ name:'icon-back', color: categoryTheme && categoryTheme.color, width:'16' }}
                    left
                    textAlign="left"
                  />}
                ButtonNext={
                  <ButtonNextWrapper
                    handleClick={propClickNext}
                    background={categoryTheme && categoryTheme.color}
                    color="#FFFFFF"
                    text={setTextButtonNext()}
                    width={140}
                    disabled={isButtonNextDisabled}
                  />}
                />
            </ButtonActionsWrapper>
          </Footer>
        </React.Fragment>
      }
    />
  )
}
